import React from 'react';
import {useToast} from "../provider/ToastProvider";
import {Alert, Snackbar} from "@mui/material";
import {checkNullStr, getDefStr} from "../utils/ReactUtils";

/**
 * Create a toast component that displays a message. It uses a provider.
 *
 * @example
 * //src/index.js: Add toast ToastProvider in your src->index.js file
 * import {ToastProvider} from "./fusion-ui/provider/ToastProvider";
 * const container = document.getElementById("root");
 * const root = createRoot(container);
 * root.render(<BrowserRouter >
 *       <ToastProvider>
 *           <App/>
 *       </ToastProvider>
 *    </BrowserRouter>
 * );
 *
 * //Add Toast in your root-component
 * import {Toast} from "./fusion-ui";
 * return (<>
 *     <RootComponent>
 *        ...
 *   </RootComponent>
 *
 *   <Toast/>
 * </>);
 *
 *
 * //Use toast in your component
 * import {useToast} from "./fusion-ui/provider/ToastProvider";
 * import {Button, Flexbox} from "./fusion-ui";
 *
 * const {showToast, toastMsg, toastHideDur, toastVariant, changeToastVariant} = useToast();
 *
 * return (
 *   <Flexbox>
 *        {['black', 'danger', 'warning', 'info', 'success', 'primary', ''].map((item, index) => {
 *            return <Button
 *                className={'text-nowrap mx-2 px-2 py-1'} key={index}
 *                variant={''}
 *                style={{ backgroundColor: `var(--${item})` }}
 *                hoverStyle={{ backgroundColor: `var(--${item})` }}
 *                color={'white'}
 *                width={'auto'}
 *                text={`${item} toast`}
 *                onClick={() => toast(`This is ${item} toast!`, item)}
 *            />
 *        })}
 *   </Flexbox>
 * );
 * function toast(text, variant) {
 *      showToast(text);
 *      changeToastVariant(variant);
 * }
 */
const Toast = React.memo(({
                              style = {},
                              message,
                              variant,
                          }) => {
    const TAG = "Toast";
    const {showToast, toastMsg, toastHideDur, toastVariant, changeToastVariant, setToastHideDur} = useToast();
    // const [open, setOpen] = useState(checkNullStr(toastMsg));

    // useEffect(() => {
    //     // console.log(TAG, 'toastMsg:', toastMsg);
    //     if (checkNullStr(toastMsg)) {
    //         setOpen(true);
    //         createTimeout(() => {
    //             // showToast('');
    //             setOpen(false);
    //         }, 3000);
    //     }
    // }, [toastMsg]);

    return (<Snackbar
            open={checkNullStr(getMsgStr())}
            // open={open}
            autoHideDuration={toastHideDur}
            onClose={(e, reason) => {
                // console.log(TAG, 'onClose.reason:', reason);
                showToast('');
                // changeToastVariant('black');
                // if (reason === 'clickaway') {
                // console.log(TAG, 'onClose.reason.clickaway-true');
                // setOpen(false);
                // return;
                // showToast('');
                // }
            }}>
            <Alert severity={getVariant()}
                   sx={{
                       width: '100%',
                       borderRadius: '.55rem',
                       boxShadow: 'var(--shadow)',
                       ...getAlertStyles(getVariant()),
                       ...style
                   }}
            >
                <span className={''}>{getMsgStr()}</span>
            </Alert>
        </Snackbar>
    );

    function getAlertStyles() {
        let bg = '';
        let color = '';
        switch (getVariant()) {
            case 'primary':
                bg = '#2586d5';
                color = '#e2f2fd';
                break;
            case 'success':
                bg = 'var(--success)';
                color = '#f0fdee';
                break;
            case 'warning':
                bg = 'var(--warning)';
                color = '#000000';
                break;
            case 'info':
                bg = '#0fc0e5';
                color = '#000000';
                break;
            case 'error':
            case 'danger':
                bg = '#ec4747';
                color = '#faf2f2';
                break;
            default :
                bg = '#000000';
                color = '#ffffff';
                break;
        }
        return {
            backgroundColor: bg,
            color: color,
            '& .MuiAlert-icon': {
                color: color,
            },
        };

    }

    function getVariant() {
        //'success' | 'info' | 'warning' | 'error'
        switch (getDefStr(variant, toastVariant)) {
            case 'primary':
                return 'primary';
            case 'success':
                return 'success';
            case 'warning':
                return 'warning';
            case 'info':
                return 'info';
            case 'error':
            case 'danger':
                return 'error';
            default :
                return 'black';
        }
    }

    function getMsgStr() {
        return getDefStr(message, toastMsg);
    }

});
export default Toast;
